import React from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './ActivityReportsPage.metadata.json5';
import styles from './ActivityReportsPage.module.scss';
import messages from './ActivityReportsPage.messages';

const REPORTS_ROW_LIMIT = 20;

const ActivityReportsPage = (props) => {
    const {
        history
    } = props;
    const translator = useTranslator();

    const overrideProps = {
        activityReportsComponent: {
            rowLimit: REPORTS_ROW_LIMIT,
            isDashboard: false,
            selectedView: _.get(history, 'location.state.reportView')
        },
        backToDashboard: {
            content: (
                <Link to='/' className={styles.backToDashboardLink}>
                    <i className="icon-ml-right-carrot-icon icon-rotate-180" />&nbsp;
                    {translator(messages.backToDashboard)}
                </Link>
            )
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={{}}
            classNameMap={styles}
        />
    );
};

ActivityReportsPage.propTypes = {
    dateLabel: PropTypes.string,
    productCodes: PropTypes.array,
    filterData: PropTypes.shape({}).isRequired,
    hideFields: PropTypes.array,
    onFilter: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    resultsRowCount: PropTypes.number.isRequired,
    updateFilterData: PropTypes.func.isRequired
};

export default withRouter(ActivityReportsPage);
